import { Scheduling } from "../../../../../../models/schedule";
import { useDealershipConsultantDaySchedule } from "../../../../../../hooks/useDealershipConsultantSchedule";
import useMediaQuery from '@mui/material/useMediaQuery';

interface IDayProps {
  firstWeekDay: Date;
  currentDate: Date;
  consultantMonthSchedule: Scheduling[];
  handleScheduling: (scheduling: Scheduling) => void;
}

const Day = ({
  firstWeekDay,
  currentDate,
  consultantMonthSchedule,
  handleScheduling,
}: IDayProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { getScheduleTask } = useDealershipConsultantDaySchedule(
    firstWeekDay,
    consultantMonthSchedule,
    handleScheduling
  );

  const timeSlots = Array.from({ length: 24 * 2 }).map((_, index) => {
    const hour = Math.floor(index / 2);
    const minute = index % 2 === 0 ? 0 : 30;
    return { hour, minute };
  });

  return (
    <table className="width-100pct table-fixed">
      <thead>
        <tr>
          <th className={`height-20 ${isMobile ? 'width-20' : 'width-10'}`}></th>
          <th style={{ width: isMobile ? 'calc(100% - 80px)' : 100 }} />
        </tr>
      </thead>
      <tbody>
        {timeSlots.map(({ hour, minute }) => {
          // const availableDateTime = !(
          //   currentDate.getDay() === 0 || // Domingo
          //   (currentDate.getDay() === 6 && hour > 12)
          // );
          const availableDateTime = true;
          return (
            <tr key={`${hour}-${minute}`}>
              <td 
                className="display-flex justify-content-center align-items-center"
                style={{ 
                  width: isMobile ? 80 : 'auto',
                  minWidth: isMobile ? 80 : 'auto',
                  fontSize: isMobile ? '12px' : '14px',
                  padding: isMobile ? '5px' : '8px'
                }}
              >
                {`${hour.toString().padStart(2, "0")}:${minute
                  .toString()
                  .padStart(2, "0")}`}
              </td>
              <td 
                style={{ 
                  height: isMobile ? 50 : 60, 
                  width: isMobile ? 'calc(100% - 80px)' : 100 
                }} 
                className="border"
              >
                {availableDateTime
                  ? getScheduleTask(currentDate, hour, minute)
                  : null}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Day;
